import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PaymentMethods from "../components/Cards/PaymentMethods";
import { executePayment, initiatePayment } from "../api/paymentApi";
import { useAuth } from "../context/AuthContext";
import { updatePayment } from "../api/paymentApi";
import { Bounce, toast } from "react-toastify";
import countriesData from "../data/countries.json";
import config from "../config";
import { useTranslation } from "react-i18next";

const RepaymentPage = () => {
  const {t}=useTranslation();
  const { orderId } = useParams();
  const navigate = useNavigate();
  const { isAuthenticated, clientData, selectedBranch } = useAuth();
  const { state } = useLocation();
  const order = state?.order;
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [selectPaymentMethod, setSelectPaymentMethod] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [contact, setContact] = useState({
      username: clientData?.username || "",
      email: clientData?.email || "",
      mobile: clientData?.mobile || "",
    });
    const [address, setAddress] = useState({
      street: clientData?.address || "",
      zone: "",
      city: "",
    });

  useEffect(() => {
    if (!clientData || !isAuthenticated){ navigate("/login"); return;}
    initiatePayments();
  }, []);

  const initiatePayments = () => {
    initiatePayment(order?.total_amount || "0.00", selectedBranch?.currency)
      .then((response) => {
        setPaymentMethods(response.Data.PaymentMethods || []);
      })
      .catch((error) => {
        console.error(t("err.init.Payment"), error);
        toast.error(t("Errorloadingpaymentmethods"));
      });
  };

  const handlePaymentMethod = (method) => {
    setSelectPaymentMethod(method);
    toast.success(`${t("PaymentMethodSelected")}: ${method.PaymentMethodEn}`);
  };

  const handlePayment = async () => {
    if (!selectPaymentMethod) {
      toast.error(t("Pleaseselectapaymentmethod"));
      return;
    }

    setProcessing(true);
    try {
      // Get country code for phone
      const code = countriesData.find(
        (option) =>
          option.countryCode.toLowerCase() ===
          selectedBranch.country.toLowerCase()
      );
      const mobilecode = code ? `+${code.dialCode}` : "";

      // Prepare payment details
      const paymentDetails = {
        PaymentMethodId: selectPaymentMethod.PaymentMethodId,
        CustomerName: contact.username,
        DisplayCurrencyIso: selectedBranch?.currency,
        MobileCountryCode: mobilecode,
        CustomerMobile: contact.mobile.replace(mobilecode, ""),
        CustomerEmail: contact.email,
        InvoiceValue: order.total_amount.toFixed(2),
        CallBackUrl: `${config.hostUrl}/paymentsuccess?OrderId=${orderId}&isJustView=false&payment_id=${order?.payments[0]?.payment_id}`,
        ErrorUrl: `${config.hostUrl}/paymentsuccess?OrderId=${orderId}&isJustView=false&payment_id=${order?.payments[0]?.payment_id}`,
        Language: "en",
        UserDefinedField: orderId,
        CustomerAddress: {
          Block: "",
          Street: address.street,
          HouseBuildingNo: "",
          Address: `${address.zone},${address.city}`,
          AddressInstructions: "",
        },
      };
      if (selectPaymentMethod?.PaymentMethodId === 100) {
        const updatepayment ={...order.payments[0],  payment_method:"cash_delivery",
            payment_status: "Pending", gateway_response:null}
            console.log(updatepayment)
    const response=    await updatePayment(updatepayment);
          toast.success(response.message, {
                  position: "top-center",
                  autoClose: false,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                  transition: Bounce,
                });
          
                //cash on delivery navigate to my orders
                if (selectPaymentMethod?.PaymentMethodId === 100) {
                  navigate("/orders");
                }
      } else{
           // Execute payment
      const paymentResponse = await executePayment(paymentDetails);

      if (paymentResponse.IsSuccess) {
        // // Update order and payment status
        // await updateOrderStatus(orderId, { payment_status: "Processing" });
        const updatepayment ={...order.payments[0],  payment_method:"credit_card",
            payment_status: "Pending", gateway_response:null}
        await updatePayment(updatepayment);

        // Redirect to payment URL
        if (paymentResponse.Data.PaymentURL) {
          window.location.href = paymentResponse.Data.PaymentURL;
        } else {
          throw new Error(t("PaymentURLismissing"));
        }
      } else {
        throw new Error(
          paymentResponse?.ValidationErrors?.[0]?.Error || t("Paymentfailed")
        );
      }
      }
   
    } catch (error) {
      toast.error(error.message);
      setProcessing(false);
    }
  };

  if (!order) return <div className="text-center p-6">{t('Loading')}</div>;

  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="bg-white rounded-lg shadow-lg">
        <div className="p-6">
          <h2 className="text-2xl font-bold mb-6">{t('CompletePayment')}</h2>
{/* Contact Information */}
<div className="mb-6">
          <h3 className="text-lg font-semibold">{t('ContactInformation')}</h3>
          <input
            type="text"
            placeholder={t("name")}
            className="w-full border p-3 mt-2 rounded-lg"
            value={contact.username}
            required
            onChange={(e) =>
              setContact({ ...contact, username: e.target.value })
            }
          />
          <input
            type="email"
            placeholder={t("email")}
            className="w-full border p-3 mt-2 rounded-lg"
            value={contact.email}
            required
            onChange={(e) => setContact({ ...contact, email: e.target.value })}
          />
          <input
            type="tel"
            placeholder={t('"mobile"')}
            className="w-full border p-3 mt-2 rounded-lg"
            value={contact.mobile}
            required
            onChange={(e) => setContact({ ...contact, mobile: e.target.value })}
          />
        </div>
        {/* Delivery Address */}
        <div className="mb-6">
          <h3 className="text-lg font-semibold">{t('DeliveryAddress')}</h3>
          <input
            type="text"
            placeholder={t("StreetAddress")}
            className="w-full border p-3 mt-2 rounded-lg"
            value={address.street}
            required
            onChange={(e) => setAddress({ ...address, street: e.target.value })}
          />
          <input
            type="text"
            placeholder={t("Zone")}
            className="w-full border p-3 mt-2 rounded-lg"
            value={address.zone}
            required
            onChange={(e) => setAddress({ ...address, zone: e.target.value })}
          />
          <input
            type="text"
            placeholder={t("City")}
            className="w-full border p-3 mt-2 rounded-lg"
            value={address.city}
            required
            onChange={(e) => setAddress({ ...address, city: e.target.value })}
          />
        </div>
          {/* Order Summary */}
          <div className="mb-6">
            <h3 className="text-lg font-semibold mb-4">{t('OrderSummary')}</h3>
            <div className="space-y-2">
              <div className="flex justify-between">
                <span>{t('OrderID')}:</span>
                <span>{order.order_id}</span>
              </div>
              <div className="flex justify-between">
                <span>{t('totalamount')}:</span>
                <span>
                  {order.total_amount.toFixed(2)} {selectedBranch?.currency}
                </span>
              </div>
            </div>
          </div>

          {/* Payment Methods */}
          <div className="mb-6">
            <h3 className="text-lg font-semibold mb-4">
              {t('selectpaymethod')}
            </h3>
            <PaymentMethods
              paymentMethods={paymentMethods}
              handlePayment={handlePaymentMethod}
            />
          </div>

          {/* Pay Button */}
          <button
            className="w-full bg-green-600 text-white py-3 rounded-lg font-semibold hover:bg-green-700 disabled:bg-gray-400"
            onClick={handlePayment}
            disabled={!selectPaymentMethod || processing}
          >
            {processing ? t('processing') :t('paynow')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RepaymentPage;
